<template>
  <el-menu
    default-active="1-4-1"
    class="el-menu-vertical-demo"
    :collapse="isCollapse"
    background-color="#545c64"
    :unique-opened="true"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <h3>{{ isCollapse ? "后台" : "后台管理系统" }}</h3>
    <sidebarItem
      v-for="route in menuData"
      :key="route.path || route.name"
      :item="route"
      :base-path="route.path || ''"
    />
  </el-menu>
</template>
<script>
import sidebarItem from "@/layout/components/SideBar/SideBarItem.vue";

export default {
  data() {
    return {};
  },
  components: {
    sidebarItem,
  },
  methods: {},
  computed: {
    menuData() {
      let result = [];
      result =
        JSON.parse(localStorage.getItem("menu")) || this.$store.state.tab.menu;
      return result;
    },
    isCollapse() {
      return this.$store.state.tab.isCollapse;
    },
  },
};
</script>
<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-menu {
  height: 100vh;
  border-right: none;

  h3 {
    color: #fff;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
